module.exports = __webpack_public_path__ + "img/activity_bcg2.22f0ab09.png";